import React, { useState } from "react";

// Images/Icons
import ViewFullAgenda from "assets/breakfast-event/svgs/view-full-agenda.svg";

// Translations
import { useTranslation } from "react-i18next";
import { AGENDAS_ENGLISH, AGENDAS_FRENCH } from "./utils/constants";

const DEFAULT_VISIBLE = 6;

const Agenda = () => {
  // Translations
  const { t } = useTranslation("event");
  const language = localStorage.getItem("selectedLanguage");

  const [showAll, setShowAll] = useState(false);

  const AGENDAS = language?.includes("fr") ? AGENDAS_FRENCH : AGENDAS_ENGLISH;

  const visibleAgendas = showAll ? AGENDAS : AGENDAS.slice(0, DEFAULT_VISIBLE);

  const morning = visibleAgendas.filter((item) => item.type === "morning");

  const afternoon = visibleAgendas.filter((item) => item.type === "afternoon");
  return (
    <div
      id="agenda"
      className="scroll-mt-[90px] bg-[#141B3D] min-h-[884px] flex justify-center items-center pt-[3rem] font-euclid"
    >
      <div className=" flex justify-center items-center flex-col text-white gap-4 w-[92%]">
        <div className="bg-[#FFC87F33] bg-opacity-20 rounded-full px-3 py-1 w-fit">
          <p className="text-base font-euclidMedium text-center">
            {t("agenda.tag")}
          </p>
        </div>
        <h1 className="text-3xl md:text-[48px] font-euclidSemibold">
          {t("agenda.title")}
        </h1>

        {/* Agenda Blocks */}
        <div className="space-y-10 mt-5 w-full">
          {morning.length > 0 && (
            <AgendaBlock
              title={language?.includes("fr") ? "Matin" : "Morning"}
              items={morning}
            />
          )}

          {afternoon.length > 0 && (
            <AgendaBlock
              title={language?.includes("fr") ? "Après-midi" : "Afternoon"}
              items={afternoon}
            />
          )}
        </div>

        {/* Toggle CTA */}
        {AGENDAS.length > DEFAULT_VISIBLE && (
          <div className="flex justify-center mt-16">
            <button
              onClick={() => setShowAll(!showAll)}
              className="border-none bg-transparent"
            >
              {showAll ? (
                <img src={ViewFullAgenda} alt="ViewFullAgenda" />
              ) : (
                <img src={ViewFullAgenda} alt="ViewFullAgenda" />
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
const AgendaItem = ({ item, index, items }) => {
  return (
    <div
      className={`${
        index + 1 === items?.length
          ? "border-none"
          : "border-b border-dashed border-[#FFE9CC]"
      } py-5 items-center px-5 text-center md:text-left`}
    >
      <span className="text-sm px-3 py-1 whitespace-nowrap border border-[#FFE9CC] rounded-full font-euclidRegular">
        {item.start_time} – {item.end_time}
      </span>

      <p className="text-base md:text-[20px] text-white mt-2 font-euclidRegular">
        {item.activity}
      </p>
    </div>
  );
};

const AgendaBlock = ({ title, items }) => {
  return (
    <div className="space-y-10 mt-5 w-full transition-all duration-300 ease-in-out">
      <div className="grid grid-cols-1 md:grid-cols-[250px_1fr] gap-0 md:gap-6 border border-dashed border-[#FFE9CC] rounded-2xl">
        {/* Left label */}
        <div className="border-b border-dashed md:border-none flex items-center justify-center py-[1rem] md:mt-0">
          <span className="text-xl md:text-[24px] font-euclidMedium text-white">
            {title}
          </span>
        </div>

        {/* Items */}
        <div className="border-none border-l md:border-dashed border-[#FFE9CC]">
          {items.map((item, index) => (
            <AgendaItem key={index} index={index} items={items} item={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
export default Agenda;
